<gl-base-modal (closeModal)="close()">
  <h2 class="title">{{ 'warning' | translate }}</h2>
  <p class="info">{{ 'max_loads_info' | translate }}</p>
  <div class="buttons">
    <button outline-button (click)="close()">{{ 'close' | translate }}</button>
  </div>
</gl-base-modal>
